jQuery(function($){
    // MW-WP-Fromのフォーム内に設置されている
    // プライバシーポリシー用<a>タグにhrefを指定する.
    // ※WPの階層が変わった際にリンク切れにならないよう
    // 静的に指定はせず、動的に生成されたリンクを転用する.
    $('#js-form-privacy-policy').attr(
        'href',
        // フッターに指定されているのURLを転用
        $('footer #js-privacy-policy').attr('href')
    );

    // アコーディオンの開閉
    $('.js-acc-header').on('click', function(){
        $(this).next('.js-acc-inner').slideToggle();
        $(this).toggleClass("open");
    });

    // フォームスライドを進める
    $('.js-paging-list-next').on('click', function(){
        let page = parseInt($(this).attr('data-page'));
        // 入力がある場合のみスライドを進める
        if (checkFilled(page)) {
            changePage(page, 1);
        }
        return false;
    });

    // フォームスライドを戻す
    $('.js-paging-list-back').on('click', function(){
        let page = parseInt($(this).attr('data-page'));
        changePage(page, -1);
        return false;
    });

    // 名前フォームでエンター押下時はフォーカス移動
    $('#name').keypress(function(e){
        if(e.which == 13){
            $('#mail').focus();
            return false;
        }
    });

    // メールフォームでエンター押下時はページ移動
    $('#mail').keypress(function(e){
        if(e.which == 13){
            let $btn = $(".js-paging-list-next").filter(function() {
                return $(this).attr('data-page') === '2';
            });
            $btn.trigger('click');
            return false;
        }
    });

    // 送信前入バリデーション 
    $('.js-paging-list-send').on('click', function(){
        // ここでバリデーション 
        if ('' === $('#company').val() ||
        '' === $('#name').val() ||
        '' === $('#mail').val() ||
        '' === $('#detail').val()
        ) {
            window.alert('未入力の項目があります。');
            return false;
        }
        const pattern = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/;
        if (!pattern.test($('#mail').val())) {
            window.alert('メールアドレスの形式に誤りがあります。');
            return false;
        }
        return true;
    });

    /**
     * スライド別にフォームが入力されているかをチェック
     */
    function checkFilled(index) {
        // スライド番号に応じてチェック
        switch (index){
            case 1:
                return '' !== $('#company').val();
            case 2:
                return '' !== $('#name').val() && '' !== $('#mail').val();
            case 3:
                return '' !== $('#detail').val();
            default:
              return false;
          }
    }

    /**
     * ページを切り替える
     */
    function changePage(index, after = 1) {
        // 現在のページを非表示
        $('.js-paging-list > li:nth-child(' + index + ')').toggleClass("open");
        // ページを表示
        $('.js-paging-list > li:nth-child(' + (index + after) + ')').toggleClass("open");
    }
});